import * as authTypes from './authTypes';

const initialState = {
  token: '',
  isAuthenticated: false,
  user: {},
  otpSent: false,
  deviceInfo:null
};

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case authTypes.SET_AUTH_USER:
      return { ...state, isAuthenticated: true, user: payload.user };

    case authTypes.SET_AUTH_USER_PERMISSIONS:
      return { ...state, isAuthenticated: true, permissions: payload.permissions };

    case authTypes.RESTORE_SESSION:
      const token = sessionStorage.getItem('token');
      return { ...state, isAuthenticated: !!token, token: token || '' };

    case authTypes.POST_OTP_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.POST_OTP_SUCCESS:
      return { ...state, loading: false, otpSent: true };

    case authTypes.POST_OTP_FAILURE:
      return { ...state, loading: false, error: payload.payload };

    case authTypes.POST_LOGIN_WITH_OTP_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.POST_LOGIN_WITH_OTP_SUCCESS:
      return { ...state, loading: false, isAuthenticated: true, token: payload.payload };

    case authTypes.POST_LOGIN_WITH_OTP_FAILURE:
      return { ...state, loading: false, error: payload.payload };

    case authTypes.POST_CONTACT_OTP_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.POST_CONTACT_OTP_SUCCESS:
      return { ...state, loading: false, isAuthenticated: true, token: payload };

    case authTypes.POST_CONTACT_OTP_FAILURE:
      return { ...state, loading: false, error: payload };


    case authTypes.DISCONNECT_CALENDAR_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: {
          ...state.user,
          isGoogleConnected: false,
        },
      };

    case authTypes.DISCONNECT_CALENDAR_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

     case authTypes.LOG_DEVICE_INFO:
      return { ...state, loading: true, error: null };

   case authTypes.LOG_DEVICE_INFO_BY_ID_SUCCESS:
  console.log('[DeviceLog] Reducer received success:', payload);
  return { ...state, loading: false, deviceInfo: payload };

case authTypes.LOG_DEVICE_INFO_BY_ID_FAILURE:
  console.log('[DeviceLog] Reducer received failure:', payload);
  return { ...state, loading: false, error: payload.payload };

    default:
      return state;
  }
};